import React from 'react';
import { Tooltip } from 'antd';
import './TooltipWrapper.scss';

const TooltipWrapper = props => {
  const { isShowTooltip, ...restProps } = props;
  /*
  isShowTooltip : boolean : tooltip visibility status
  restProps : default : antd default tooltip props
  */
  if (isShowTooltip) {
    return (
      <Tooltip {...restProps} destroyTooltipOnHide>
        {props.children}
      </Tooltip>
    );
  }
  return props?.children;
};
export default TooltipWrapper;
